export function lowerFirstLetter(text) {
    return `${text.charAt(0).toLowerCase()}${text.slice(1)}`;
}

export const capitalize = ([firstLetter, ...otherLetters]) => [firstLetter.toUpperCase(), ...otherLetters]
    .join('');

export const pluralize = (word) => {
    if (word.endsWith('y')) {
        return `${word.substring(0, word.length - 1)}ies`;
    }

    return `${word}s`;
}
